import React from 'react';
import Lottie from 'react-lottie';
import scale from './lotties/animation_scale';
import collab from './lotties/animation_collab.json'; 
import map from './lotties/animation_map.json'; 
import marker from './lotties/animation_mapmarker.json'; 
import worldmap from './lotties/animation_worldmap.json'; 
import infinity from './lotties/animation_infinity.json'; 
import infinityloop from './lotties/animation_infinityloop.json'; 
import infinitywhite from './lotties/infinity_white.json'; 
import list from './lotties/animation_list.json'; 
import loader from './lotties/animation_loader.json'; 

const anims = {
    scale, worldmap, marker, map, collab, infinity, infinityloop, infinitywhite, loader, list
}

export default function Loader({animationName, width, height}) {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: anims[animationName],
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <div>
        <Lottie 
          options={defaultOptions}
          height={height||400}
          width={width||400}
        />
      </div>
    );
  }